import { addToast, Button } from '@octano/global-ui';
import { useCallback } from 'react';
import { Col, Row } from 'reactstrap';
import { useActionKitImp } from '../../../../components/ozmoit/common/action-kit-imp';
import { downloadFromBlob } from '../../../../utils/blob';
import { exportStudentsRiskHistoryAction } from './actions';
import { StudentsRiskHistoryLoader } from './hooks/StudentsRiskHistoryLoader';

export function DownloadButton(props: { readonly disabled: boolean }) {
  const { query } = StudentsRiskHistoryLoader();

  const { action: handleExport, loading: exporting } = useActionKitImp(
    exportStudentsRiskHistoryAction,
    {
      onSuccess: () => {
        addToast({
          color: 'success',
          text: 'Listado descargado exitosamente',
        });
      },
      onError: {
        unknown: () => {
          addToast({
            color: 'danger',
            text: 'Error al descargar el listado',
          });
        },
      },
    },
  );

  const handlePressExport = useCallback(async () => {
    if (exporting || !query.schoolId || !query.year || !query.periodId) {
      return;
    }
    const response = await handleExport({
      schoolId: Number(query.schoolId),
      year: Number(query.year),
      periodId: Number(query.periodId),
    });
    console.log('response.data.data', response);

    if (!response.success) {
      return;
    }

    if ((response.data as File).size === 0) {
      return;
    }

    const blob = new Blob([response.data], {
      type: 'vnd.ms-excel',
    });
    downloadFromBlob(blob, 'historial-riesgo-estudiantes.xlsx');
  }, [handleExport, query, exporting]);

  return (
    <Row className="mt-3">
      <Col xs={12} className="d-flex justify-content-end">
        <Button
          disabled={props.disabled}
          text="Descargar listado"
          size="md"
          type="button"
          icon="download"
          loading={exporting}
          outlined
          onClick={handlePressExport}
        />
      </Col>
    </Row>
  );
}
